module.exports = __webpack_public_path__ + "static/pc-57847092c742f9ae454366c52853adf2.svg";